import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filters: {
        fechaInicio: new Date(),
        fechaFin: new Date(),
        idTipo: 0,
        serie: "",
        numero: 0,
        dniCobrador: "",
        cobrador: "",
        dniPagador: "",
        pagador: "",
        idEstadoPago: 0,
        idEstado: 0,
    },
    listTipo: [],
    listEstadoPago: [],
    listEstado: [],
    results: [],
}

export const receiptSearchSlice = createSlice({
    name: "receiptSearch",
    initialState,
    reducers: {
        setValue: (state, action) => {
            const { name, value } = action.payload;

            state.filters[name] = value;
        },
        setResults: (state, action) => {
            state.results = action.payload;
        },
        setListTipo: (state, action) => {
            state.listTipo = action.payload;
        },
        setListEstadoPago: (state, action) => {
            state.listEstadoPago = action.payload;
        },
        setListEstado: (state, action) => {
            state.listEstado = action.payload;
        },
    },
});

export const { setValue, setResults
    , setListTipo, setListEstadoPago, setListEstado
    } = receiptSearchSlice.actions;
export default receiptSearchSlice.reducer;
